import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';

export interface LogEntry {
  date: string;
  time: string;
  file: string;
  line: number;
  message: string;
}

export interface LogResponse {
  records: LogEntry[];
  total: number;
  fileSize: number;
  lastModified: string;
}

@Injectable({ providedIn: 'root' })
export class LogService {
  constructor(private httpClient: HttpClient) { }

  getLogs(search: string = '', limit: number = 500, offset: number = 0) {
    return this.httpClient.post<any>(`${environment.apiEndPoint}logs/read`, { search, limit, offset })
      .pipe(
        map(res => res ? res.document as LogResponse : null),
        catchError(this.handleError)
      );
  }

  private handleError(error: any): Promise<any> {
    let retour = error?.error?.message || error?.message || error;
    if (error?.error?.data) retour += '<br />' + error?.error?.data;
    return Promise.reject(retour);
  }
}
